import { useContext, useRef, useEffect, useState } from 'react';
import { ScopeContext } from '@bingads-webui-react/scope-service';

import URI from 'urijs';

/**
 * A simple hook to store a vairable's value for compare use
 * TODO: move this hook to a shared place
 * @param {any} value the value to get its previous version
 * @returns {any} previous value
 */
const usePrevious = (value) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};

/**
 * A wrapper to detect scope changes that requires full page refresh to solve the context mismatch issue
 * TODO: Move this logic to Router level or Remove after context could dynamically update
 * @param {Props} Props only children
 * @returns {ReactNode} rendered result
 */
export const ScopeSwitchingReloader = ({ children }) => {
  const { scope } = useContext(ScopeContext);

  // As the DOM update and full page refresh are run in parallel
  // If we decide to do FPR, disable children content update to make the transition smoother
  const [passing, setPassing] = useState(true);

  const {
    values: { cid, aid } = {},
  } = scope;

  const prevCid = usePrevious(cid);
  const prevAid = usePrevious(aid);


  useEffect(() => {
    // when the page is loaded in browser, all values from usePrevious hook will be undefined
    const isFirstLoaded = !prevAid && !prevCid;
    if (
      !isFirstLoaded &&
      (prevCid !== cid || prevAid !== aid)
    ) {
      setPassing(false);
      window.location.replace(new URI(scope.location.pathname).search(scope.stringify()).toString());
    }
  }, [aid, cid, prevAid, prevCid, scope]);

  return passing ? children : null;
};

